import { lazy } from "../../lib/lazy.ts";
import type { Engine } from "./types.ts";

/** The PDF library the viewer uses: PDF.js, loaded the first time a PDF is shown (its own chunk). Tests swap it. */
export const pdfEngine: { load: () => Promise<Engine> } = {
  load: lazy(() => import("./engine.ts").then((m) => m.engine)),
};
